<template>
  <v-card height="auto" elevation="0">
    <v-container>
      <v-row dense>
        <v-col lg="12" md="12" sm="12" xs="12">
          <v-img
            class="mx-2"
            width="auto"
            src="https://www.risoul.com.mx/hs-fs/hubfs/Banner_Asesoria.png?width=257&name=Banner_Asesoria.png"
          />
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
export default {
  name: "child_ProductDetailBaner2",

  components: {},

  data() {
    return {
      title: "",
    };
  },

  props: {},

  methods: {},

  computed: {},

  watch: {},

  created() {},

  mounted() {},
};
</script>

<style>
.image1 img {
  width: 70px;
  height: 45px;
}

.image2 img {
  width: 110px;
  height: 60px;
}

.image3 img {
  width: 130px;
  height: 40px;
}

.image4 img {
  width: 160px;
  height: 80px;
}

.image5 img {
  width: 90px;
  height: 55px;
}
</style>
